export default {
  profile: '/profile',
  leave_applications: '/leave-applications',
  myleave: '/my-leave',
  my_e_letters: '/e-letter',
}
